/**
 *
 * @module productStatus
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef ProductStatus
 * @type {Object}
 * @since 3.0.1
 * @desc Defines the different status a Product can be in.
 * @example ProductStatus.AVAILABLE // 'AVAILABLE'
 *
 * @property {String} AVAILABLE - The product is currently available.
 * @property {String} UNKNOWN - The product status is unknown.
 * @property {String} UNAVAILABLE - The product is currently unavailable.
 *
 */

/**
 *
 * @enum
 * @type {ProductStatus}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    AVAILABLE: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    UNKNOWN: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    UNAVAILABLE: null
});



// WEBPACK FOOTER //
// ./src/subscription/productStatus.js